export const subscriptionStatuses = {
  notSubscribed: "not_subscribed",
  subscribed: "subscribed",
  subscribedWaitingForPause: "subscribed_waiting_for_pause",
  subscribedWaitingForPauseBlockedByCloset: "subscribed_waiting_for_pause_blocked_by_closet",
  subscribedWaitingForCancelation: "subscribed_waiting_for_cancelation",
  subscribedWaitingForCancelationBlockedByCloset: "subscribed_waiting_for_cancelation_blocked_by_closet",
  pastDue: "past_due",
  pastDueWaitingForPause: "past_due_waiting_for_pause",
  pastDueWaitingForCancelation: "past_due_waiting_for_cancelation",
  paused: "paused",
  canceled: "canceled",
};
